import { Component, effect, input, output, ChangeDetectionStrategy } from '@angular/core';
import { SafeStyle } from '@angular/platform-browser';
import { StyleHelper } from '@xanadu/common';

@Component({
    selector: 'app-option',
    templateUrl: './option.component.html',
    styleUrls: ['./option.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OptionComponent {
    readonly model = input<any>();
    readonly meta = input<any>();
    readonly formGroup = input<any>();

    delete = output<any>();

    labelStyle?: SafeStyle;
    valueStyle?: SafeStyle;

    show: boolean = false;

    constructor(
        private readonly styleHelper: StyleHelper
    ) {
        effect(() => {
            const meta = this.meta();
            const model = this.model();
            const formGroup = this.formGroup();

            this.show = !!model && !!meta && !!formGroup;

            if (meta) {
                if (meta.label.style) {
                    this.labelStyle = this.styleHelper.parse(meta.label.style);
                }
                if (meta.value.style) {
                    this.valueStyle = this.styleHelper.parse(meta.value.style);
                }
            }
        });
    }

    onDelete(option: any) {
        this.delete.emit(option);
    }
}
